import React from 'react';
import { useHistory } from 'react-router';
import Spinner from '../../components/common/spinner';
import Header from '../../components/common/global-top-bar';
import { ExternalProviderPlan, useExternalProviderPlans } from '../../hooks/useExternalProviderPlans';
import ExternalProviderPlanModal from './plus-care-edit';
import { ROUTE_PATH } from '../../routes/paths';

const NEW_PLAN: ExternalProviderPlan = {
  code: '',
  display_name: '',
  name: '',
  provider: '',
  provider_types: [],
  recuro_metatag3: '',
};

const PlusCarePage: React.FC = () => {
  const history = useHistory();
  const { data, isLoading } = useExternalProviderPlans();

  return (
    <div>
      <Header heading={'+Care'} />
      <div className="bg-gray-background-light flex min-h-10 items-center justify-end gap-2 overflow-visible px-7 py-2">
        <button
          type="button"
          className="border-blue-primary text-blue-primary hover:bg-blue-primary shrink-0 rounded-sm border px-2 py-2 text-center text-sm hover:text-white"
          onClick={() => history.push(ROUTE_PATH.PLUS_CARE_CONTENT)}
          data-testid="plus-care-manage-content-button"
        >
          Manage Content
        </button>
        <ExternalProviderPlanModal plan={NEW_PLAN} />
      </div>
      <div className="max-window-height overflow-y-auto pb-10">
        <div className="w-full px-3">
          {isLoading ? (
            <Spinner />
          ) : (
            <table className="table-row-format relative w-full table-fixed border-collapse">
              <thead className="sticky top-0 h-full bg-white">
                <tr className="w-full px-7 pt-5 text-left">
                  <th className="sticky top-0 mb-4 h-full w-1/12 bg-white px-2 py-2"></th>
                  <th className="sticky top-0 mb-4 h-full w-1/12 bg-white px-2 py-2 pl-2">
                    <p className="px-2">Id</p>
                  </th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">
                    <p className="ml-4 px-2">Plan Name</p>
                  </th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">Plan Code</th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">Display Name</th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">
                    <p className="ml-1">Provider</p>
                  </th>
                  <th className="sticky top-0 mb-4 h-full w-3/12 bg-white px-2 py-2">
                    <p className="ml-4">Plan Type</p>
                  </th>
                  <th className="sticky top-0 mb-4 h-full w-2/12 bg-white px-2 py-2">Metatag 3</th>
                </tr>
              </thead>
              <tbody>
                {data
                  ?.sort((a, b) => a.id! - b.id!)
                  .map((externalProviderPlan) => (
                    <tr key={externalProviderPlan.id} className="cursor-pointer">
                      <td className="w-1/12 px-2 py-2">
                        <ExternalProviderPlanModal plan={externalProviderPlan} />
                      </td>
                      <td className="w-1/12 px-2 py-2">{externalProviderPlan.id}</td>
                      <td className="w-2/12 px-2 py-2">{externalProviderPlan.name}</td>
                      <td className="w-2/12 px-2 py-2">{externalProviderPlan.code}</td>
                      <td className="w-2/12 px-2 py-2">{externalProviderPlan.display_name}</td>
                      <td className="w-2/12 px-2 py-2">{externalProviderPlan.provider}</td>
                      <td className="w-3/12 px-2 py-2">{externalProviderPlan.provider_types.join(', ')}</td>
                      <td className="w-2/12 px-2 py-2">{externalProviderPlan.recuro_metatag3}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlusCarePage;
